import * as THREE from "three";
import { setOrbitControlsEnabled } from "../Camera";
// Custom rotation controls class
import { addEventListener } from "@/helpers/clickManager";
import {
  MovementTypes,
  undoMovementList,
} from "../teethControls/TeethPositionHelper";
export default class CustomRotationControls {
  constructor() {
    this.camera = null;
    this.controls = null;
    this.domElement = window;
    this.object = null;
    this.setAutoSave = null;
    this.isRotating = false;
    this.selectedAxis = null;
    this.startMousePosOnAxis = new THREE.Vector2();
    this.startRotation = 0;
    this.rotationSpeed = 0.01;

    this.mainGroup = null;
    this.raycaster = new THREE.Raycaster();
    this.mouse = new THREE.Vector2();
    this.axes = []; // Holds x, y, z axis meshes
    this.selectedAttachmentInitialRotation = new THREE.Euler();
    this.selectedAttachment = null;
    this.up = new THREE.Vector3(0, 1, 0);
    this.forward = new THREE.Vector3(0, 0, 1);
    this.right = new THREE.Vector3(1, 0, 0);
    this.xAxis = null;
    this.yAxis = null;
    this.zAxis = null;
    this.verticalAxisRatio = 1 / 4;
    this.gizmosHoveredColor = "#FF0000";
    this.gizmosDefaultColor = "#77BBDA";
    this.gizmosMaterial = new THREE.MeshStandardMaterial({
      color: this.gizmosDefaultColor,
      depthTest: false,
      transparent: true,
    });
    // Bind event handlers to the class context
    this.onMouseDown = this.onMouseDown.bind(this);
    this.onMouseMove = this.onMouseMove.bind(this);
    this.onMouseUp = this.onMouseUp.bind(this);
    this.createAxes();
  }
  // Method to attach an object and add controls
  attach(object) {
    this.mainGroup.visible = true;
    if (object) {
      // Position and scale the axes
      this.update(object);
    }
    this.object = object;
    if (this.object.name === "_att") this.setRealCenter();
    // Create axes when an object is attached

    // Add event listeners for rotation
    this.addEventListeners();
  }

  // Method to detach the object and remove controls
  detach() {
    try {
      const groupToRemove = this.mainGroup;
      if (groupToRemove) {
        groupToRemove.removeFromParent();
        groupToRemove.visible = false;
      }
    } catch (err) {
      console.log(err);
    }
    this.object = null;
  }

  createAxes() {
    if (!this.mainGroup) {
      const curve = new THREE.QuadraticBezierCurve3(
        new THREE.Vector3(-2, 0, 0),
        new THREE.Vector3(0, 2, 0),
        new THREE.Vector3(2, 0, 0),
      );

      const createAxis = (color, name) => {
        const AxisGroup = new THREE.Group();

        const tubeGeometry = new THREE.TubeGeometry(curve, 20, 0.15, 8, false);
        const tubeMaterial = this.gizmosMaterial.clone();
        const tubeMesh = new THREE.Mesh(tubeGeometry, tubeMaterial);
        tubeMesh.name = name;
        AxisGroup.add(tubeMesh);

        const arrowHeadGeometry = new THREE.ConeGeometry(0.17, 0.6, 6);
        const arrowHeadMaterial = tubeMaterial;

        const arrowHead1 = new THREE.Mesh(arrowHeadGeometry, arrowHeadMaterial);
        arrowHead1.name = name;
        arrowHead1.position.set(-2.18, -0.21, 0);
        arrowHead1.rotation.z = Math.PI / 1.3;

        AxisGroup.add(arrowHead1);

        const arrowHead2 = new THREE.Mesh(arrowHeadGeometry, arrowHeadMaterial);
        arrowHead2.name = name;
        arrowHead2.position.set(2.18, -0.21, 0);
        arrowHead2.rotation.z = Math.PI / -1.3;
        AxisGroup.add(arrowHead2);
        const setAxisColor = (axisGroup, color) => {
          axisGroup.children.forEach(part => {
            part.material.color.set(color);
          });
        };

        // Add hover effect for each part of the axis group
        [tubeMesh, arrowHead1, arrowHead2].forEach(part => {
          addEventListener(
            part,
            "mouseover",
            () => {
              setAxisColor(AxisGroup, this.gizmosHoveredColor);
              this.isOn = true;
            },
            0,
          );
          addEventListener(
            part,
            "mouseout",
            () => {
              setAxisColor(AxisGroup, this.gizmosDefaultColor);
              this.isOn = false;
            },
            0,
          );
        });
        addEventListener(
          arrowHead1,
          "mousedown",
          e => {
            // console.log(e);
            this.onMouseDown(e.object);
          },
          0,
        );
        addEventListener(
          arrowHead2,
          "mousedown",
          e => {
            // console.log(e);
            this.onMouseDown(e.object);
          },
          0,
        );
        addEventListener(
          tubeMesh,
          "mousedown",
          e => {
            // console.log(e);
            this.onMouseDown(e.object);
          },
          0,
        );
        return AxisGroup;
      };
      // Create X, Y, Z axes
      this.xAxis = createAxis(this.gizmosDefaultColor, "zAxis");
      this.yAxis = createAxis(this.gizmosDefaultColor, "xAxis");
      this.zAxis = createAxis(this.gizmosDefaultColor, "yAxis");

      // addEventListener(yAxis, "mousedown", e => {
      //   if (yAxis.uuid === e) console.log(e, yAxis);
      // });
      // addEventListener(zAxis, "mousedown", e => {
      //   if (zAxis.uuid === e) console.log(e, zAxis);
      //   console.log(e, zAxis);
      // });
      const mainGroup = new THREE.Group();
      const sGroup = new THREE.Group();
      mainGroup.name = "Attachments ori group";
      sGroup.add(this.xAxis, this.yAxis, this.zAxis);
      sGroup.position.z += 0.9;
      mainGroup.add(sGroup);

      mainGroup.scale.set(1.2, 1.2, 1.2);

      this.mainGroup = mainGroup;

      this.axes = [this.xAxis, this.yAxis, this.zAxis];
    }
  }
  setCamera(camera) {
    this.camera = camera;
  }

  setScene(scene) {
    this.scene = scene;
  }

  setControls(controls) {
    this.controls = controls;
  }
  setRealCenter() {
    if (this.object.geometry && this.object.geometry.isBufferGeometry) {
      this.object.geometry.computeBoundingBox();
      const boundingBox = this.object.geometry.boundingBox;
      const center = boundingBox.getCenter(new THREE.Vector3());
      this.object.geometry.translate(-center.x, -center.y, -center.z);
      this.object.position.add(center);

      // Adjust children positions to maintain relative positions
      if (this.object.children)
        this.object.children.forEach(child => {
          child.position.sub(center);
        });
    }
  }
  // Remove axes from the scene when detaching or disposing
  removeAxes() {
    this.object.parent.remove(this.mainGroup);
  }
  attatchControls(controls) {
    this.controls = controls;
  }
  addEventListeners() {
    // this.domElement.addEventListener("mousedown", this.onMouseDown);
    this.domElement.addEventListener("mousemove", this.onMouseMove);
    this.domElement.addEventListener("mouseup", this.onMouseUp);
  }

  removeEventListeners() {
    // this.domElement.removeEventListener("mousedown", this.onMouseDown);
    this.domElement.removeEventListener("mousemove", this.onMouseMove);
    this.domElement.removeEventListener("mouseup", this.onMouseUp);
  }

  // Hide other axes when one is selected
  hideOtherAxes(selectedName) {
    this.axes.forEach(axis => {
      if (axis.children[0].name !== selectedName) {
        axis.visible = false;
      } else {
        axis.children.forEach(e => {
          e?.material?.color.set(this.gizmosHoveredColor);
        });
      }
    });
  }

  // Show all axes when mouse is released
  showAllAxes() {
    this.axes.forEach(axis => {
      axis.visible = true;
      axis.children.forEach(e => {
        e?.material?.color.set(this.gizmosDefaultColor);
      });
    });
  }

  onMouseDown(object) {
    if (object) {
      this.selectedAttachmentInitialRotation =
        this.object?.rotation?.clone() || new THREE.Euler();
      this.selectedAttachment = this.object;

      this.isRotating = true;
      this.startMousePosOnAxis.x = 0;
      this.startMousePosOnAxis.y = 0;
      // Select the axis based on object name
      if (object.name === "xAxis") {
        // this.controls.enabled = false;
        setOrbitControlsEnabled(false);
        this.selectedAxis = "x";
        this.startRotation = this.object?.rotation?.x || 0;
      } else if (object.name === "yAxis") {
        // this.controls.enabled = false;
        setOrbitControlsEnabled(false);
        this.selectedAxis = "y";
        this.startRotation = this.object?.rotation?.y || 0;
      } else if (object.name === "zAxis") {
        // this.controls.enabled = false;
        setOrbitControlsEnabled(false);
        this.selectedAxis = "z";
        this.startRotation = this.object?.rotation?.z || 0;
      }

      // Hide the other axes
      this.hideOtherAxes(object.name);
    }
  }

  onMouseMove(event) {
    if (this.isRotating && this.selectedAxis) {
      if (
        this.startMousePosOnAxis.x === 0 &&
        this.startMousePosOnAxis.y === 0
      ) {
        this.startMousePosOnAxis.x = event.clientX;
        this.startMousePosOnAxis.y = event.clientY;
        return;
      }
      let delta, deltaX, deltaY;

      deltaX = event.clientX - this.startMousePosOnAxis.x;
      deltaY = event.clientY - this.startMousePosOnAxis.y;

      delta =
        Math.abs(deltaX) > Math.abs(deltaY)
          ? deltaX
          : -deltaY * this.verticalAxisRatio;
      // Apply rotation based on selected axis

      if (this.selectedAxis === "x") {
        this.object.rotateOnAxis(this.right, delta * this.rotationSpeed);
      } else if (this.selectedAxis === "y") {
        this.object.rotateOnAxis(this.up, delta * this.rotationSpeed);
      } else if (this.selectedAxis === "z") {
        this.object.rotateOnAxis(this.forward, delta * this.rotationSpeed);
      }
      this.startMousePosOnAxis.x = event.clientX;
      this.startMousePosOnAxis.y = event.clientY;
    }
  }
  isHovered() {
    return this.isOn;
  }
  onMouseUp() {
    // this.controls.enabled = true;

    // save undo withOld rotation

    if (this.selectedAttachment) {
      if (
        this.selectedAttachment.rotation !=
          this.selectedAttachmentInitialRotation &&
        this.isRotating
      ) {
        this.registerToUndo();
        this.update(this.object);
        if (this.setAutoSave) {
          this.setAutoSave();
        }
      }
    }
    setOrbitControlsEnabled(true);

    this.isRotating = false;
    this.selectedAxis = null;

    // Show all axes again when mouse is released
    this.showAllAxes();
  }
  update(object) {
    if (object) {
      this.xAxis.position.y = 0.85;
      this.yAxis.rotation.x = 1.57;
      this.yAxis.rotation.y = 1.57 - object.rotation.z;
      this.yAxis.scale.set(0.8, 0.8, 0.8);
      this.zAxis.rotation.x = 1.57;
      this.zAxis.rotation.y = -object.rotation.z;
      this.zAxis.position.z = -0.1;
      this.zAxis.scale.set(0.8, 0.8, 0.8);

      // Add axes to the scene and store them for later removal
      this.mainGroup.position.copy(object.position);
      this.mainGroup.rotation.copy(object.rotation);
      this.mainGroup.rotation.y += Math.PI;
      this.mainGroup.rotation.z = Math.PI;

      object.parent.add(this.mainGroup);
    }
  }
  // Cleanup method to remove everything
  dispose() {
    this.detach();
  }

  registerToUndo() {
    undoMovementList.push({
      action: "rotate",
      actionType: MovementTypes.ATTACHMENTS,
      attachmentID: this.object.customID,
      attachmentName: this.object.name,
      rotation: this.selectedAttachmentInitialRotation,
      tooth: this.object?.parent?.parent,
    });
  }
}
